// DS: i7.18
import React from 'react';
import IconWrap from '../../IconWrap';
const EditorHRule = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M20 6a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 002 0V7h12v1a1 1 0 102 0V6zM17 12a1 1 0 01-1 1H8a1 1 0 110-2h8a1 1 0 011 1zM20 18a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 112 0v1h12v-1a1 1 0 112 0v2z"
    })));
};
EditorHRule.displayName = 'EditorUnderline';
export default EditorHRule;

//# sourceMappingURL=EditorHRule.js.map